<template>
  <div>
    <FilterPanel v-model="filter" :skip-filter="true" @refresh="refresh" />
    <RealtimeChart
      v-if="!!Object.keys(chartData).length"
      :data="chartData"
      :axes="axes"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onUnmounted } from 'vue'

import useRouter from '@/hooks/useRouter'

import NaRespondedJob from '@/utils/responded_job'
import { IRespondedJob } from '@/interfaces/respondedJobs'

import RealtimeChart from '@/components/Reports/RealtimeChart.vue'
import FilterPanel from './FilterPanel.vue'
import moment from 'moment'
import { ElMessage } from 'element-plus'

export default defineComponent({
  name: 'TabRealtime',
  components: {
    RealtimeChart,
    FilterPanel
  },
  props: {
    jid: {
      type: String,
      default: null
    },
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const { router } = useRouter()
    const filter = ref({})
    const axes = [{ title: 'Impressions', value: 'clicks' }]

    const job = new NaRespondedJob(
      (error: string, args: any) => {
        context.emit('update:modelValue', false)
        filter.value = { ...filter.value, ...args }
        ElMessage.error(error)
      },
      (id: string) => {
        router.replace({
          name: 'reports-tab-result',
          params: { tab: 'realtime', jid: id }
        })
      },
      () => {
        context.emit('update:modelValue', false)
        router.replace({ name: 'reports-tab', params: { tab: 'realtime' } })
      }
    )

    const fillJobData = (job: IRespondedJob) => {
      context.emit('update:modelValue', false)

      if (
        Array.isArray(job.attributes.result) ||
        Array.isArray(job.attributes.result.graph)
      ) {
        return
      }
      chartData.value = job.attributes.result.graph
      filter.value = { ...job.attributes.args }
    }

    if (props.jid) {
      context.emit('update:modelValue', true)
      job.setAfterJobCallback(fillJobData)
      job.checkJobWithInterval(props.jid)
    }

    onUnmounted(() => {
      job.destroy()
    })

    const chartData = ref({})

    const refresh = (newFilter: any) => {
      context.emit('update:modelValue', true)
      chartData.value = {}
      const payload = {
        ...newFilter,
        group_by: 'one_min',
        period: `${moment().subtract(1, 'd').format('DD.MM.YYYY')} - ${moment().format('DD.MM.YYYY')}`
      }

      job.runRespondedJob('type_traforama_report', payload, fillJobData)
    }

    return {
      refresh,
      chartData,
      filter,
      axes
    }
  }
})
</script>
